import styled from 'styled-components'


const FretWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

/** @component */
export default FretWrapper
